/** Те саме правило, що в lib/userDirectory.js (fallback для name з API без novapay-fop-options). */
export function stripPatronymicFromOfficialFopTitle(raw) {
    const s = String(raw || "")
        .trim()
        .replace(/\s+/g, " ");
    if (!s) return "";
    const parts = s.split(" ");
    if (parts.length >= 4) return parts.slice(0, -1).join(" ");
    return s;
}
